/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type QuestionType = "HelpWithFindingUninterruptedTimeToFocus" | "HelpWithSchedulingExternalMeetingsEffortlessly" | "HelpWithSettingHealthyWorkLifeBoundaries" | "HelpWithSimplifyingSchedulingWithCoworkers" | "HelpWithSomethingElse" | "HowDidYouHearAboutClockwise" | "HowManyPeopleOnTeam" | "WhatIsYourCurrentPosition" | "WhatTypeOfWorkDoYouDo" | "%future added value";
export type ResponseType = "AccountingOrFinance" | "Administrative" | "Between10And15" | "Between15And20" | "Between5And9" | "BusinessOwner" | "Checked" | "CustomerSupport" | "DesignOrUxResearch" | "DirectorOrDepartmentLeader" | "ExecutiveOrBusinessLeader" | "FoundOnline" | "FriendOrFamily" | "IDoNotKnow" | "IDoNotWorkOnAnyTeams" | "IndividualContributor" | "InternetSearch" | "It" | "Legal" | "LessThan5" | "Manager" | "Marketing" | "MoreThan20" | "MyMeetingsOnAutopilot" | "OnlineAdvertisement" | "Operations" | "Other" | "PeopleOpsOrHr" | "ProductManagement" | "ProgramOrProjectManagement" | "Recruiting" | "SalesOrBusinessDevelopment" | "SocialMedia" | "SoftwareEngineering" | "TeammateAutopilot" | "TeammateCalendar" | "TeammateFocusTime" | "TeammateInvited" | "TeammatePersonalCalendar" | "TeammatePrepTime" | "TeammateSlackStatus" | "TeammateTravelTime" | "Unchecked" | "VpOrDivisionLeader" | "%future added value";
export type OnboardingSurvey_org = {
    readonly id: string;
    readonly userSurveyResponseWrapperErrorable: {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        readonly __typename: "UserSurveyResponseWrapper";
        readonly id: string;
        readonly userSurveyResponses: ReadonlyArray<{
            readonly questionType: QuestionType | null;
            readonly responseType: ResponseType | null;
            readonly questionText: string | null;
            readonly responseText: string | null;
        }>;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $refType": "OnboardingSurvey_org";
};
export type OnboardingSurvey_org$data = OnboardingSurvey_org;
export type OnboardingSurvey_org$key = {
    readonly " $data"?: OnboardingSurvey_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"OnboardingSurvey_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "OnboardingSurvey_org",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "userSurveyResponseWrapperErrorable",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "statusCode",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "message",
                                "storageKey": null
                            }
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserSurveyResponse",
                                "kind": "LinkedField",
                                "name": "userSurveyResponses",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "questionType",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "responseType",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "questionText",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "responseText",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "UserSurveyResponseWrapper",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '0d41fad21a739b3f7452dd375860b0cb';
export default node;
